import { render, staticRenderFns } from "./HonorPanel.vue?vue&type=template&id=a94b7fae&scoped=true"
import script from "./HonorPanel.vue?vue&type=script&lang=js"
export * from "./HonorPanel.vue?vue&type=script&lang=js"
import style0 from "./HonorPanel.vue?vue&type=style&index=0&id=a94b7fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b7fae",
  null
  
)

export default component.exports